import styled, { css } from 'styled-components';
import { BadgeOverlay } from 'react-rainbow-components';
import Card from 'components/Card';
import Input from 'components/Input';
import {
    GREY_100, GREY_200, GREY_300, GREY_800,
    PURPLE_100, PURPLE_500,
} from '../../../constants';

export const StyledCard = styled(Card)`
    height: calc(100vh - 161px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div`
    display: flex;
    height: calc(100vh - 161px);
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    align-self: stretch;
    gap: 1.5rem;
    flex: 1;
`;

export const TableContainer = styled.div`
    padding: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
`;

export const EmptyMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 6rem auto 1rem auto;
    padding: 0 1rem;
    gap: 0.5rem;
    width: 100%;
    max-width: 35rem;
`;

export const EmptyMessageEmoji = styled.h2`
    font-size: 3.5rem;
    font-weight: 500;
    line-height: 150%;
`;

export const EmptyMessageTitle = styled.h1`
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 2rem;
    color: ${GREY_800};
`;

export const EmptyMessageDescription = styled.p`
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: ${GREY_800};
`;

export const SearchInput = styled(Input)`
    flex: 1;
    min-width: 14rem;
    margin-top: 4px;
    
    input[disabled] {
        pointer-events: none;
        background: transparent;
        border: none;
        
        ::placeholder {
            color: ${GREY_200} !important;
        }
    }

    ${(props) => props.disabled && css`
        span {
            color: ${GREY_100} !important;
        }
    `};
`;

export const SearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.5rem;
`;

export const RightContent = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 2rem 1rem 1rem 1.25rem;
    height: fit-content;
    z-index: 1;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 40%);
    margin-top: -2rem;
    z-index: 1;
`;

export const EntriesText = styled.span`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${GREY_300};
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    ${(props) => props.variant === 'brand' && css`
        & > span {
            background: ${PURPLE_100};
            color: ${PURPLE_500};
        }
    `};
`;
